import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class CatalogStorageService {
  async withLock<T>(key: string, action: () => Promise<T>): Promise<T> {
    if (typeof navigator === 'undefined' || !navigator.locks) return action();
    let started = false;
    try {
      return await navigator.locks.request(key, () => {
        started = true;
        return action();
      });
    } catch (error) {
      if (started) throw error;
      // Restricted WebViews can expose Web Locks but deny access to them.
      return action();
    }
  }

  read(key: string): string | null {
    try { return localStorage.getItem(key); } catch { return null; }
  }

  write(key: string, value: string): void {
    try { localStorage.setItem(key, value); } catch { /* A valid network response remains usable. */ }
  }
}
